import { agentMcpUrls, agentAssistants, agentSetupGuideUrls } from '../config/agent-onboarding.js';

export const agentPromptVersion = 3;
export const agentFeedbackDuration = 2000;

export function normalizeAgentOnboardingUrl(value) {
  if (value == null) return value;
  let url;
  try { url = typeof value === 'string' ? new URL(value) : null; } catch { /* Report one configuration error below. */ }
  if (!url || !['https:', 'http:'].includes(url.protocol) || url.username || url.password) {
    throw new TypeError('[PositiveNav] agentOnboardingUrl must be an absolute HTTP(S) URL without credentials, or null.');
  }
  return url.href;
}

/** UI translations never change the prompt or the MCP server URL. */
export function resolveAgentOnboarding(product, override, urls = agentMcpUrls, providers = agentAssistants, guides = agentSetupGuideUrls) {
  if (!product || override === null) return null;
  const configuredUrl = (value) => normalizeAgentOnboardingUrl(
    typeof value === 'string' && !value.trim() ? null : value) ?? null;
  const url = override === undefined ? configuredUrl(urls[product.id]) : normalizeAgentOnboardingUrl(override);
  const assistants = Object.freeze(Object.fromEntries(providers.flatMap(({ id, directoryUrls }) => {
    const directoryUrl = configuredUrl(directoryUrls?.[product.id]);
    if (!directoryUrl && !url) return [];
    return [[id, Object.freeze({ mode: directoryUrl ? 'connect' : 'copy', url: directoryUrl ?? url })]];
  })));
  if (!Object.keys(assistants).length) return null;
  const setupGuideUrl = url ? configuredUrl(guides[product.id]) : null;
  return Object.freeze({
    productId: product.id,
    name: product.name,
    url: url ?? null,
    setupGuideUrl,
    assistants,
    prompt: url ? `Help me connect this agent to ${product.name} using its remote MCP server: ${url}. `
      + 'If you can configure MCP connections, add this server; otherwise, guide me through the setup in this agent\'s settings. '
      + 'Let me complete any required sign-in and authorization, then verify the connection by listing the available tools.'
      + (setupGuideUrl ? ` For client-specific setup instructions, refer to ${setupGuideUrl}.` : '') : null,
  });
}
